import React from 'react'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'

export const GoogleReCaptchaWrapper = ({children}: {children: React.ReactNode}) => (
    <GoogleReCaptchaProvider
        reCaptchaKey={process.env.GATSBY_RECAPTCHA_V3_SITE_KEY!}
        scriptProps={{async: true, defer: true, appendTo: 'body'}}
    >
        {children}
    </GoogleReCaptchaProvider>
)
